(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["glovia-mobile-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('glovia-mobile-buy')) {
  customElements.define('glovia-mobile-buy', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById('MainProduct-' + this.dataset.section);
      this.main = document.getElementById('ProductSubmitButton-' + this.dataset.section);
      this.price = document.getElementById('price-' + this.dataset.section);
      this.action = this.querySelector('button');
      if (!this.root || !this.main || !this.price) return;
      this.mobile = matchMedia('(max-width: 749px)');
      this.update = () => {
        const label = this.main.querySelector('span');
        const busy = this.main.classList.contains('loading');
        this.cod = this.root.querySelector('[id="rsi_buy_now_button"]');
        this.action.textContent = this.main.disabled ? (label ? label.textContent.trim() : this.main.textContent.trim()) : this.dataset.orderLabel;
        this.action.disabled = this.main.disabled || this.main.getAttribute('aria-disabled') === 'true' || busy || !this.cod || this.cod.disabled || this.cod.getAttribute('aria-disabled') === 'true';
        this.action.setAttribute('aria-busy', String(busy));
        const current = this.price.querySelector('.price__sale .price-item--sale') || this.price.querySelector('.price-item--regular');
        if (current) this.querySelector('strong').textContent = current.textContent.trim();
        this.visibility();
      };
      this.visibility = () => {
        const past = (this.cod || this.main).getBoundingClientRect().bottom < 0;
        const overlay = document.querySelector('cart-notification.active, #cart-notification.active, cart-drawer.active, dialog[open], .menu-drawer-container[open]');
        const typing = document.activeElement?.matches('textarea, select, input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]):not([type="button"]):not([type="submit"]):not([type="range"])');
        this.hidden = !this.mobile.matches || !past || Boolean(overlay) || typing || !this.cod;
        document.body.classList.toggle('glovia-mobile-buy-visible', !this.hidden);
      };
      this.action.addEventListener('click', () => {
        const cod = this.root.querySelector('[id="rsi_buy_now_button"]');
        if (!this.action.disabled && cod && !cod.disabled) { cod.click(); this.visibility(); }
      });
      this.stateObserver = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.update();
      });
      this.stateObserver.observe(this.root, {attributes:true,attributeFilter:['disabled','aria-disabled','class'],childList:true,subtree:true,characterData:true});
      this.error = this.root.querySelector('.product-form__error-message-wrapper');
      if (this.error) {
        this.errorObserver = new MutationObserver(() => {
          if (!this.error.hidden && this.error.textContent.trim()) this.error.scrollIntoView({block:'center'});
        });
        this.errorObserver.observe(this.error, {attributes:true,childList:true,subtree:true});
      }
      this.modalObserver = new MutationObserver(this.visibility);
      this.modalObserver.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['open']});
      this.overlayObserver = new MutationObserver(this.visibility);
      document.querySelectorAll('cart-notification, #cart-notification, cart-drawer').forEach(el => this.overlayObserver.observe(el,{attributes:true,attributeFilter:['class']}));
      window.addEventListener('scroll',this.visibility,{passive:true});
      window.addEventListener('resize',this.visibility);
      document.addEventListener('focusin',this.visibility);
      document.addEventListener('focusout',this.visibility);
      this.update();
    }
    disconnectedCallback() {
      this.stateObserver?.disconnect();
      this.errorObserver?.disconnect();
      this.overlayObserver?.disconnect();
      this.modalObserver?.disconnect();
      window.removeEventListener('scroll',this.visibility);
      window.removeEventListener('resize',this.visibility);
      document.removeEventListener('focusin',this.visibility);
      document.removeEventListener('focusout',this.visibility);
      document.body.classList.remove('glovia-mobile-buy-visible');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
